/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { AxiosError } from 'axios';
import axiosConfig, { ApiRequestType } from 'axiosConfig/axiosConfig';
import { AdminSettings, AdminSettingsId, AdminSettingsResponse, AdminUpdateResponse } from 'models/viewModels';

class AdminSettingsApi {
  async getAdminSettingsBySettingsId(settingsId: AdminSettingsId): Promise<AdminSettingsResponse> {
    return new Promise<AdminSettingsResponse>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .get('/rest/admin', { params: { settingsId } })
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }

  async updateAdminSettings(settingsId: AdminSettingsId, settings: string): Promise<AdminUpdateResponse> {
    const request: AdminSettings = {
      settingsId,
      settings,
    };
    return new Promise<AdminUpdateResponse>((resolve, reject) =>
      axiosConfig(ApiRequestType.MotorsportsCompToolsApi)
        .post('/rest/admin', request)
        .then((res) => resolve(res.data))
        .catch((error: AxiosError) => reject(new AxiosError(error.message, error.code)))
    );
  }
}

export const adminSettingsApi = new AdminSettingsApi();
